const shouldHighlightHeaderLink = (toMatchPathname: string, inputPathname: string, useContains = false): boolean => {
  return (
    inputPathname === `/${toMatchPathname}` ||
    inputPathname === `/${toMatchPathname}/` ||
    inputPathname.split('/').pop() === toMatchPathname
  );
};

export const isOnDegreePage = (pathname: string): boolean => {
  return shouldHighlightHeaderLink('degrees', pathname);
};

export const isOnMyLearningPage = (pathname: string): boolean => {
  return shouldHighlightHeaderLink('my-learning', pathname);
};
